export default "__VITE_ASSET__CIKBVAfd__"